<script>
import Dropdown from './Dropdown.vue'
import request from '@/utils/request'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: Dropdown, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        textField: {
            type: String,
            default: 'title',
        },
        valueField: {
            type: String,
            default: '_id',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            options: [],
        }
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },

        /***
         * Setting values to show in Perview Form
         */
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                if (this.field.key == 'basicInfo.genderId') {
                    //console.log('FieldName ' + this.field.key)
                    //console.log('basicInfo.genderId ' + selectedItem.title)

                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: selectedItem.title,
                    })
                }

                if (this.field.key == 'contactInfo.stateId') {
                    //console.log('FieldName ' + this.field.key)
                    //console.log('contactInfo.stateId ' + selectedItem.title)

                    this.$store.commit('updateField', {
                        key: 'contactInfo.state',
                        value: selectedItem.title,
                    })
                }

                if (this.field.key == 'accountInfo.purposeOfActionId') {
                    //console.log('FieldName ' + this.field.key)
                    console.log(
                        'accountInfo.purposeOfActionId ' + selectedItem.title
                    )

                    this.$store.commit('updateField', {
                        key: 'accountInfo.purposeOfAction',
                        value: selectedItem.title,
                    })
                }

                if (this.field.key == 'occupationInfo.industryId') {
                    //console.log('FieldName ' + this.field.key)
                    console.log(
                        'occupationInfo.industryId ' + selectedItem.title
                    )

                    this.$store.commit('updateField', {
                        key: 'occupationInfo.industry',
                        value: selectedItem.title,
                    })
                }
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        await this.getRecords()
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * get the dropdown values when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                // fetch the list of associated configurations
                // let { data } = await request({
                //     url: `/configurations/${this.field.association}`,
                //     params: {
                //         dataSegmentId: this.dataSegmentId,
                //         status: 'active',
                //         perPage: 1000,
                //         ref: 'dropdown',
                //     },
                // })
                let data
                // update the local list of options
                if (this.field.association == 'cities') {
                    ;({ data } = await request({
                        url: `/configurations/${this.field.association}`,
                        params: {
                            perPage: 1000,
                            ref: 'dropdown',
                        },
                    }))
                    //console.log(data.data)
                } else {
                    ;({ data } = await request({
                        url: `/configurations/${this.field.association}`,
                        params: {
                            dataSegmentId: this.dataSegmentId,
                            status: 'active',
                            perPage: 1000,
                            ref: 'dropdown',
                        },
                    }))
                }

                this.options = data.data
                if (this.field.type === 'isd-code') {
                    this.options = this.options.filter((item) => {
                        item.isdCodeTitle = `${item.title} (${item.isdCode})`
                        return item
                    })
                }
            } catch (error) {
                //console.log(error)
            }
        }, // End of getRecords() method
    }, // End of Component > watch
}
</script>
